import { render, staticRenderFns } from "./rewardLeapfrogEdit.vue?vue&type=template&id=76138334&scoped=true&"
import script from "./rewardLeapfrogEdit.vue?vue&type=script&lang=js&"
export * from "./rewardLeapfrogEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76138334",
  null
  
)

export default component.exports